import React, { useEffect, useState, useRef } from 'react';
import Droppable from '../DnD/Droppable';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import VImage from '../VImage/VImage';
import _ from 'lodash';
import styled from 'styled-components';
import { generateImageLink } from '../../utils/design.utils';
import './VGrid.css';

const Grid = props => {
  const entity = useSelector(state => state.design.entitiesState[props.entityId]);
  const authToken = useSelector(state => state.authentication.user.authToken);
  const [gridSize, setGridSize] = useState({
    w: parseInt(_.get(entity, 'style.master.width', props.size.width)),
    h: parseInt(_.get(entity, 'style.master.height', props.size.height)),
  });
  const medias = _.get(entity, 'data.medias', {});

  const target = useRef(null);
  const gridConf = {
    gap: entity.data.gap,
    template: entity.data.template,
  };

  // useEffect(() => {
  //   console.log('Grid entity', entity);
  // }, [entity]);
  const Observer = new MutationObserver(mutations => {
    mutations.forEach(mutationRecord => {
      let newWidth = parseInt(mutationRecord.target.style.width);
      let newHeight = parseInt(mutationRecord.target.style.height);
      if (!newWidth) {
        newWidth = parseInt(props.size.width);
        newHeight = parseInt(props.size.height);
      }

      setGridSize({ ...gridSize, w: newWidth, h: newHeight });
    });
  });

  const rowsCount = _.get(gridConf, 'template.rows[0]')
    ? gridConf.template.rows.length
    : gridConf.template.areas.length;
  const columnsCount = _.get(gridConf, 'template.columns[0]')
    ? gridConf.template.columns.length
    : gridConf.template.areas[0].length;

  const templateAreas = _.flattenDeep(gridConf.template.areas);
  const areaGroupsByCols = _.chunk(templateAreas, columnsCount);
  const _areaGroupsByRows = () => {
    const baseCounts = { cols: 0, rows: 0 };
    let cols = [];
    for (let i = 0; i < columnsCount; i++) {
      cols[i] = [];
      baseCounts.cols += gridConf.template.columns && gridConf.template.columns[i];
      for (let j = 0; j < rowsCount; j++) {
        cols[i][j] = templateAreas[columnsCount * j + i];
        baseCounts.rows += gridConf.template.rows && gridConf.template.rows[j];
      }
    }
    baseCounts.rows = baseCounts.rows / baseCounts.cols;
    if (!baseCounts.cols || isNaN(baseCounts.cols)) baseCounts.cols = columnsCount;
    if (!baseCounts.rows || isNaN(baseCounts.rows)) baseCounts.rows = rowsCount;
    return { cols: cols, baseCounts: baseCounts };
  };

  const areas = _areaGroupsByRows();
  const areaGroupsByRows = areas.cols;
  const itemList = _.uniq(templateAreas);
  const itemWidth = parseInt(gridSize.w) / areas.baseCounts.cols; // - gridConf.gap / 2;
  const itemHeight = parseInt(gridSize.h) / areas.baseCounts.rows; // - gridConf.gap / 2;
  const gridStyle = () => {
    let areas = '';
    areaGroupsByCols.map(cols => {
      areas = areas + "'" + _.join(cols, ' ') + "' ";
    });
    const rows = _.join(gridConf.template.rows, 'fr ') + 'fr';
    const columns = _.join(gridConf.template.columns, 'fr ') + 'fr';
    const gridTemplate = {
      gridTemplateRows: rows,
      gridTemplateColumns: columns,
      gridTemplateAreas: areas,
      gap: gridConf.gap + 'px',
    };

    return gridTemplate;
  };
  let itemsSize = {};
  let itemsPosition = {};

  const getItemsSize = () => {
    const heightsArray = [];
    const widthsArray = [];

    for (let i = 0; i < columnsCount; i++) {
      if (rowsCount !== areas.baseCounts.rows) {
        let rowsSize = {};
        areaGroupsByRows[i].forEach((row, index) => {
          rowsSize = { ...rowsSize, [row]: gridConf.template.rows[index] };
        });
        heightsArray[i] = rowsSize;
        heightsArray[0] = { ...heightsArray[0], ...heightsArray[i] };
      } else {
        heightsArray[i] = _.countBy(areaGroupsByRows[i]);
        heightsArray[0] = { ...heightsArray[0], ...heightsArray[i] };
      }
    }
    const heights = heightsArray[0];
    for (let j = 0; j < rowsCount; j++) {
      if (columnsCount !== areas.baseCounts.cols) {
        let colsSize = {};
        areaGroupsByCols[j].forEach((col, index) => {
          let size = gridConf.template.columns[index];
          if (_.has(colsSize, col)) {
            size += colsSize[col];
          }
          colsSize = { ...colsSize, [col]: size };
        });
        widthsArray[j] = colsSize;
        widthsArray[0] = { ...widthsArray[0], ...widthsArray[j] };
      } else {
        widthsArray[j] = _.countBy(areaGroupsByCols[j]);
        widthsArray[0] = { ...widthsArray[0], ...widthsArray[j] };
      }
    }
    const widths = widthsArray[0];
    for (let k = 0; k < itemList.length; k++) {
      itemsSize = {
        ...itemsSize,
        [itemList[k]]: {
          w: itemWidth * widths[itemList[k]] + gridConf.gap * (widths[itemList[k]] - 1),
          h: itemHeight * heights[itemList[k]] + gridConf.gap * (heights[itemList[k]] - 1),
        },
      };
    }
    getItemsPositions();
  };

  const getItemsPositions = () => {
    let x;
    let y;
    areaGroupsByCols.map(cols => {
      cols.map((col, index) => {
        if (index === 0) {
          x = 0;
        } else {
          x = itemsSize[cols[index - 1]].w + itemsPosition[cols[index - 1]].x + gridConf.gap;
        }
        if (cols[index] !== cols[index - 1])
          itemsPosition = {
            ...itemsPosition,
            [col]: {
              x: x,
            },
          };
      });
    });

    areaGroupsByRows.map(rows => {
      rows.map((row, index) => {
        if (index === 0) {
          y = 0;
        } else {
          y = itemsSize[rows[index - 1]].h + itemsPosition[rows[index - 1]].y + gridConf.gap;
        }
        if (rows[index] !== rows[index - 1])
          itemsPosition = {
            ...itemsPosition,
            [row]: { x: itemsPosition[row].x, y: y },
          };
      });
    });
  };

  if (Object.keys(itemsSize).length === 0) getItemsSize();

  useEffect(() => { });

  const itemsStyle = area => {
    if (props.division)
      return {
        width: itemsSize[area].w,
        height: itemsSize[area].h,
        transform: `translate(${itemsPosition[area].x}px, ${itemsPosition[area].y}px)`,
        position: 'absolute',
      };

    return { gridArea: area, width: itemsSize[area].w, height: itemsSize[area].h };
  };

  const GridItem = props => {
    let media = {};
    if (props.src) {
      media.src = props.src;
      media.type = props.type;
    } else {
      media = medias && medias[props.area] ? medias[props.area] : '';
    }

    if (media !== '') {
      return (
        <VImage
          internal
          entityId={props.entityId}
          dataTarget={props.areaId}
          src={media.src}
          type={media.type}
          parentSize={props.parentSize}
        />
      );
    } else {
      return (
        <div
          className="fullWH emptyItem"
          style={{
            backgroundImage: `url("${generateImageLink(`${process.env.REACT_APP_FILE_SERVER}/resources/grids/gridPic/grid.jpg`, authToken)}")`,
          }}
        ></div>
      );
    }
  };

  const gridItems = itemList.map((area, index) => {
    const style = itemsStyle(area);
    return (
      <div key={index} className="gridItem" style={style}>
        <Droppable
          internal
          pageId={props.pageId}
          entityId={props.entityId}
          acceptList={['Image', 'Video']}
          area={area}
        >
          <GridItem
            area={area}
            src=""
            type=""
            parentSize={{ width: style.width, height: style.height }}
            areaId={`${props.entityId}_${area}`}
            entityId={props.entityId}
          />
        </Droppable>
      </div>
    );
  });

  const gridStyled = gridStyle();
  let Div;
  if (props.division) {
    Div = styled.div``;
  } else {
    Div = styled.div`
      grid-template-areas: ${gridStyled.gridTemplateAreas};
      grid-template-rows: ${gridStyled.gridTemplateRows};
      grid-template-columns: ${gridStyled.gridTemplateColumns};
      gap: ${gridStyled.gap};
    `;
  }

  return (
    <div
      ref={target}
      data-lock={entity.lock}
      id={`_${props.entityId}_`}
      data-type={props.dataType}
      data-page={props.pageId}
      className={props.className}
      data-target={props.dataTarget}
      style={entity.style.master}
      onMouseDown={props.onMouseDown}
      onMouseOver={props.onMouseOver}
    >
      <div
        className="vGrid"
        style={{
          gridTemplateAreas: gridStyled.gridTemplateAreas,
          gridTemplateRows: gridStyled.gridTemplateRows,
          gridTemplateColumns: gridStyled.gridTemplateColumns,
          gap: gridStyled.gap,
        }}
      >
        {gridItems}
      </div>
    </div>
  );
};

Grid.propTypes = {
  division: PropTypes.bool,
  entityId: PropTypes.number,
  pageId: PropTypes.number,
  className: PropTypes.string,
  dataTarget: PropTypes.string,
  onMouseDown: PropTypes.func,
  onMouseOver: PropTypes.func,
  size: PropTypes.any,
  dataType: PropTypes.any,
  areaId: PropTypes.any,
  parentSize: PropTypes.any,
  src: PropTypes.any,
  type: PropTypes.any,
  area: PropTypes.any,
};

export default Grid;
